import { useEffect, useState } from 'react';
import spinner from './spinner.png';

function UpdateSnapshot() {
  const [inputValue, setInputValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [responseMsg, setresponseMsg] = useState('');
  const [jobId, setJobId] = useState(null);
  const [status, setStatus] = useState('idle');  
  const [currentVersion, setCurrentVersion] = useState('');
  const [zipResponseMsg, setzipResponseMsg] = useState('');

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    setLoading(true);
    setresponseMsg('');   
    startUpdate();
    setTimeout(startDownload, 20000);
  };

  const startUpdate = async  () => {
    const body = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( { version:inputValue})
    };

    const res = await fetch('/api/update-init', body);
    const data = await res.json();
    if(data.taskId)
      setJobId(data.taskId);
    setStatus('processing');   
  };

  const startDownload = async  () => {
    let isDone = false;
    
    console.log("Starting spanshot download in batches...");

    while (!isDone) {
      try {
          const response = await fetch('/api/update-snapshot', { method: 'POST' });
          const data = await response.json();

          setresponseMsg(`${data.remaining} files left...`);
          setJobId(data.taskId);
          
          await new Promise(r => setTimeout(r, 5000));     

          if(data.error) {
            console.log('Error during batch: ' + data.error);
            await new Promise(r => setTimeout(r, 5000));            
          }

          if (data.done) {
            isDone = true;
            console.log("✅ Download complete!");
            
            setresponseMsg(`Unzipping packages...`);
            unzipPackages();
          }
      } catch (err) {
          console.error("Batch failed, retrying in 2 seconds...", err);
          await new Promise(r => setTimeout(r, 2000));
      }
    }  
  };

  const unzipPackages = async () => {
    let hasZipData = true;
    
    //Begin Unzip
    do {
      const res = await fetch('/api/unzip');
      const data = await res.json();
      hasZipData = data.hasData;
      setJobId(data.taskId);
      setresponseMsg(`Unzipping packages, ${data.remainingFiles} files left...`);  
    } while (hasZipData);

    if (!hasZipData) {
      setStatus('completed'); 
      setresponseMsg('Snapshot updated successfully!');
      setLoading(false);    
      
      //Let user know if there were any errors
      const res = await fetch('/api/unzip-errors');
      const data = await res.json(); 
      if(data?.numOfErrors > 0)
        setzipResponseMsg('We encountered some errors while unzipping, please reach out to RbA team.')        
    }
  }

  useEffect(() => {
    let intervalId;
    
    if (jobId && status === 'processing') {
      // Check status every 30 seconds
      intervalId = setInterval(async () => {
        try {
          const res = await fetch(`/api/snapshot-status/${jobId}`);
          const data = await res.json();
          
          if (data.status === 'complete') {
            clearInterval(intervalId);
            console.log('Complete Snapshot download and unzip!')          
          } else if (data.status === 'error') {
            setStatus('error');
            setLoading(false);    
            setresponseMsg('Something went wrong, please try again!');
          }
        } catch (err) {
          console.error("Syncing error:", err);
        }
      }, 30000); 
    }

    return () => clearInterval(intervalId);
  }, [jobId, status]);

  async function getCurrentSnapshotVersion() {
    try {
      const res = await fetch(`/api/snapshot-version/`);
      const data = await res.json();
      
      if (data) {
        setCurrentVersion(data.version);
      } 
    } catch (err) {
      console.error("Cannot retrieve current snapshot version, error:", err);
    }
  }
   useEffect( () => { 
      getCurrentSnapshotVersion();
   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[]);

  if (loading) {
    return <div className="updateVis container">
        <h3>Syncing in progress...</h3>        
        {spinner && <img src={spinner} className="App-logo" alt="logo" />}        
        <h4>{responseMsg}</h4>
      </div>;
  }
 
  return (
   <>
   <div className="updateVis container">
      <h1>
        Update Visualizer Snapshot
      </h1>
      <div hidden={currentVersion && currentVersion?.length <= 0}><h3>Current Snapshot Version: {currentVersion}</h3></div>
      <input
      className='text-input'
        type="text"
        placeholder="Enter snapshot version."
        value={inputValue} 
        onChange={handleInputChange}
      />
      <button className='btn-primary' onClick={handleButtonClick}>Update</button>
    </div>  
    <div className="updateVis container" hidden={responseMsg && responseMsg?.length <= 0}><h2>{responseMsg}</h2></div>
    <div className="updateVis container" hidden={zipResponseMsg && zipResponseMsg?.length <= 0}><h2>{zipResponseMsg}</h2></div>
   </>  
  );
}

export default UpdateSnapshot;